// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.technics-form__form__fields {
    padding: var(--space) var(--space);
}
.technics-form__form__actions {
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.technics-form__form__fields__primary-position {
    margin-top: var(--space);
}
.technics-form__form__fields__primary-position__positions-graph {
    max-width: 350px;
    margin: 0 auto;
    position: relative;
}
.technics-form__form__fields__primary-position__positions-graph__field {
    display: flex;
    justify-content: center;
    align-items: center;
}
.technics-form__form__fields__primary-position__positions-graph__position {
    position: absolute;
    min-width: var(--space-x3);
    min-height: var(--space-x2-and-half);
    width: var(--space-x3);
    height: var(--space-x2-and-half);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    box-shadow: 0px 2px 4px #AAC1B6;
    background: var(--white-color);
}
.technics-form__form__fields__primary-position__positions-graph__position:hover {
    background-color: var(--hover-pb-bg-color);
    box-shadow: var(--shadow-hover-pb);
    cursor: pointer;
}
.technics-form__form__fields__primary-position__positions-graph__position:active {
    background-color: var(--active-pb-bg-color);
}
.technics-form__form__fields__primary-position__positions-graph__position img {
    width: 33%;
}
.technics-form__form__fields__primary-position__positions-graph__position p {
    font-family: var(--secondary-font) !important;
    font-style: normal;
    font-weight: bold !important;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.modal2.technics-form .modal2__container{
    width: 30%;
}

.technics-form__subtitle.baloa-subtitle-2{
    color: var(--primary-very-dark-color);
    margin: 24px 0 0 40px;
}

@media screen and (max-width: 1100px){
    .modal2.technics-form .modal2__container{
        width: 50%;
    }
}

@media screen and (max-width: 650px){
    .modal2.technics-form .modal2__container{
        width: 70%;
    }
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .modal2.technics-form .modal2__container{
        width: 100%;
        margin: 0;
        border-radius: 0;
        height: 100vh;
        max-height: 100%;
    }
    
    .technics-form .modal2__header__title{
        margin: 12px 0;
        padding: 0;
    }

    .technics-form__form__actions{
        position: fixed;
        bottom: 0;
    }

    .technics-form {
        height: 100vh;
    }

    .technics-form__form__fields__primary-position__positions-graph{
        max-width: 100%;
    }

    button.button.primary-button.technics-form__form__submit{
        width: 100%;
    }

    .modal2.technics-form .positions-field__positions__position{
        width: calc(var(--space-x3) + var(--space-x2));
        height: calc(var(--space-x3) + var(--space-x2));
    }

    .modal2.technics-form .pos-por {
        left: calc( 50% - calc(var(--space-x2) + var(--space-half)) );
        bottom: 0px;
    }

    .modal2.technics-form .pos-li {
        left: 0;
        top: 71%;
    }

    .modal2.technics-form .pos-dci {
        left: calc( 25% );
        top: 71%;
    }

    .modal2.technics-form .pos-dcd {
        right: calc( 25% );
        top: 71%;
    }

    .modal2.technics-form .pos-ld {
        right: 0;
        top: 71%;
    }

    .modal2.technics-form .pos-mcd {
        left: calc( 50% - calc(var(--space-x2) + var(--space-half)) );
        top: 57%;
    }
    
    .modal2.technics-form .pos-mi {
        left: var(--space-quarter);
        top: 41%;
    }

    .modal2.technics-form .pos-mc {
        left: calc( 50% - calc(var(--space-x2) + var(--space-half)) );
        top: 41%;
    }

    .modal2.technics-form .pos-md {
        right: var(--space-quarter);
        top: 41%;
    }

    .modal2.technics-form .pos-ei {
        left: var(--space-quarter);
        top: 24%;
    }

    .modal2.technics-form .pos-mco {
        left: calc( 50% - calc(var(--space-x2) + var(--space-half)) );
        top: 24%;
    }

    .modal2.technics-form .pos-ed {
        right: var(--space-quarter);
        top: 24%;
    }

    .modal2.technics-form .pos-dc {
        left: calc( 50% - calc(var(--space-x2) + var(--space-half)) );
        top: 8%;
    }

    .technics-form__subtitle.baloa-subtitle-2{
        margin: 24px 0 0 12px;
    }
    
}
`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-technics-primary-position-modal/ProfileTechnicsPrimaryPositionModalComponent.styles.css"],"names":[],"mappings":";AACA;IACI,kCAAkC;AACtC;AACA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,oCAAoC;IACpC,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,8BAA8B;AAClC;AACA;IACI,0CAA0C;IAC1C,kCAAkC;IAClC,eAAe;AACnB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,UAAU;AACd;AACA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,WAAW;QACX,SAAS;QACT,gBAAgB;QAChB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,8CAA8C;QAC9C,+CAA+C;IACnD;;IAEA;QACI,6DAA6D;QAC7D,WAAW;IACf;;IAEA;QACI,OAAO;QACP,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,QAAQ;QACR,QAAQ;IACZ;;IAEA;QACI,6DAA6D;QAC7D,QAAQ;IACZ;;IAEA;QACI,0BAA0B;QAC1B,QAAQ;IACZ;;IAEA;QACI,6DAA6D;QAC7D,QAAQ;IACZ;;IAEA;QACI,2BAA2B;QAC3B,QAAQ;IACZ;;IAEA;QACI,0BAA0B;QAC1B,QAAQ;IACZ;;IAEA;QACI,6DAA6D;QAC7D,QAAQ;IACZ;;IAEA;QACI,2BAA2B;QAC3B,QAAQ;IACZ;;IAEA;QACI,6DAA6D;QAC7D,OAAO;IACX;;IAEA;QACI,qBAAqB;IACzB;;AAEJ","sourcesContent":["\n.technics-form__form__fields {\n    padding: var(--space) var(--space);\n}\n.technics-form__form__actions {\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.technics-form__form__fields__primary-position {\n    margin-top: var(--space);\n}\n.technics-form__form__fields__primary-position__positions-graph {\n    max-width: 350px;\n    margin: 0 auto;\n    position: relative;\n}\n.technics-form__form__fields__primary-position__positions-graph__field {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.technics-form__form__fields__primary-position__positions-graph__position {\n    position: absolute;\n    min-width: var(--space-x3);\n    min-height: var(--space-x2-and-half);\n    width: var(--space-x3);\n    height: var(--space-x2-and-half);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 4px;\n    box-shadow: 0px 2px 4px #AAC1B6;\n    background: var(--white-color);\n}\n.technics-form__form__fields__primary-position__positions-graph__position:hover {\n    background-color: var(--hover-pb-bg-color);\n    box-shadow: var(--shadow-hover-pb);\n    cursor: pointer;\n}\n.technics-form__form__fields__primary-position__positions-graph__position:active {\n    background-color: var(--active-pb-bg-color);\n}\n.technics-form__form__fields__primary-position__positions-graph__position img {\n    width: 33%;\n}\n.technics-form__form__fields__primary-position__positions-graph__position p {\n    font-family: var(--secondary-font) !important;\n    font-style: normal;\n    font-weight: bold !important;\n    font-size: 12px;\n    line-height: 16px;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n}\n\n.modal2.technics-form .modal2__container{\n    width: 30%;\n}\n\n.technics-form__subtitle.baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n    margin: 24px 0 0 40px;\n}\n\n@media screen and (max-width: 1100px){\n    .modal2.technics-form .modal2__container{\n        width: 50%;\n    }\n}\n\n@media screen and (max-width: 650px){\n    .modal2.technics-form .modal2__container{\n        width: 70%;\n    }\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .modal2.technics-form .modal2__container{\n        width: 100%;\n        margin: 0;\n        border-radius: 0;\n        height: 100vh;\n        max-height: 100%;\n    }\n    \n    .technics-form .modal2__header__title{\n        margin: 12px 0;\n        padding: 0;\n    }\n\n    .technics-form__form__actions{\n        position: fixed;\n        bottom: 0;\n    }\n\n    .technics-form {\n        height: 100vh;\n    }\n\n    .technics-form__form__fields__primary-position__positions-graph{\n        max-width: 100%;\n    }\n\n    button.button.primary-button.technics-form__form__submit{\n        width: 100%;\n    }\n\n    .modal2.technics-form .positions-field__positions__position{\n        width: calc(var(--space-x3) + var(--space-x2));\n        height: calc(var(--space-x3) + var(--space-x2));\n    }\n\n    .modal2.technics-form .pos-por {\n        left: calc( 50% - calc(var(--space-x2) + var(--space-half)) );\n        bottom: 0px;\n    }\n\n    .modal2.technics-form .pos-li {\n        left: 0;\n        top: 71%;\n    }\n\n    .modal2.technics-form .pos-dci {\n        left: calc( 25% );\n        top: 71%;\n    }\n\n    .modal2.technics-form .pos-dcd {\n        right: calc( 25% );\n        top: 71%;\n    }\n\n    .modal2.technics-form .pos-ld {\n        right: 0;\n        top: 71%;\n    }\n\n    .modal2.technics-form .pos-mcd {\n        left: calc( 50% - calc(var(--space-x2) + var(--space-half)) );\n        top: 57%;\n    }\n    \n    .modal2.technics-form .pos-mi {\n        left: var(--space-quarter);\n        top: 41%;\n    }\n\n    .modal2.technics-form .pos-mc {\n        left: calc( 50% - calc(var(--space-x2) + var(--space-half)) );\n        top: 41%;\n    }\n\n    .modal2.technics-form .pos-md {\n        right: var(--space-quarter);\n        top: 41%;\n    }\n\n    .modal2.technics-form .pos-ei {\n        left: var(--space-quarter);\n        top: 24%;\n    }\n\n    .modal2.technics-form .pos-mco {\n        left: calc( 50% - calc(var(--space-x2) + var(--space-half)) );\n        top: 24%;\n    }\n\n    .modal2.technics-form .pos-ed {\n        right: var(--space-quarter);\n        top: 24%;\n    }\n\n    .modal2.technics-form .pos-dc {\n        left: calc( 50% - calc(var(--space-x2) + var(--space-half)) );\n        top: 8%;\n    }\n\n    .technics-form__subtitle.baloa-subtitle-2{\n        margin: 24px 0 0 12px;\n    }\n    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
